module.exports = __webpack_public_path__ + "img/User-centeredmanagement_ic.7c5cde6.png";